//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';

export class LendingLibraryHistorySearchOptions extends ItemBase {
    SearchText: string | null = null;
    MinDateLoaned: string | null = null;
    MaxDateLoaned: string | null = null;
    StudentID: string | null = null;
    TeacherID: string | null = null;
    ItemID: string | null = null;

    constructor(initializer?: Partial<LendingLibraryHistorySearchOptions>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "LendingLibraryHistorySearchOptions";
}
